<template>
  <div class="rightconover">
    <div class="contentwidth">
      <div class="ContentMargin">
        <div class="content_down">
          <div class="content_head">
            <div class="content_head_ico">
              <img src="../../assets/images/estorage/content_title_ico_blue.png" alt="" />
            </div>
            <div class="content_head_title" v-show="redactState === 0">
              新增质检
            </div>
            <div class="content_head_title" v-show="redactState === 1">
              质检详情
            </div>
            <div class="content_head_title" v-show="redactState === 2">
              质检编辑
            </div>
            <div class="content_head_button">
              <lk-button img="save.png" @click="saveButton()" v-show="redactState === 0" style="margin-right: 20px">保存
              </lk-button>
              <lk-button img="save.png" @click="updateButton()" v-show="redactState === 2" style="margin-right: 20px">保存
              </lk-button>
              <lk-button img="back.png" @click="goBack" type="lk_button_blue">返回</lk-button>
            </div>
          </div>
          <div class="content_element">
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>质检编号</span>
              </div>
              <el-input v-model="dataSet.number" placeholder="请输入内容" disabled maxlength="15"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>仓房</span>
              </div>
              <el-cascader v-model="warehouseNumber" :options="barnInfoList" placeholder="请选择仓房" filterable
                @change="getBarnData(warehouseNumber[1])" :disabled="redactState === 1 || redactState === 2"></el-cascader>
            </div>
            <!--            <div class="content_element_only">-->
            <!--              <div class="content_element_only_title">-->
            <!--                <span>仓房类型</span>-->
            <!--              </div>-->
            <!--              <el-input v-model="dataSet.warehouseType" placeholder="" disabled maxlength="15"></el-input>-->
            <!--            </div>-->
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>粮食性质</span>
              </div>
              <el-input v-model="dataSet.grainNature" placeholder="" disabled maxlength="15"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>粮权所属</span>
              </div>
              <el-input v-model="dataSet.grainBelong" placeholder="" disabled maxlength="15"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>粮食品种</span>
              </div>
              <el-input v-model="dataSet.foVariety" placeholder="" disabled maxlength="15"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>粮食等级</span>
              </div>
              <el-input v-model="dataSet.foGrade" placeholder="" disabled maxlength="15"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>数量(吨)</span>
              </div>
              <el-input v-model="dataSet.quantity" placeholder="" disabled maxlength="30"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>扦样人</span>
              </div>
              <el-input v-model="dataSet.qyrxm" placeholder="请输入扦样人，多人请使用英文逗号‘,’分隔" maxlength="30"
                :disabled="redactState === 1"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>扦样时间</span>
              </div>
              <el-date-picker v-model="dataSet.qysj" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择扦样时间"
                :disabled="redactState === 1">
              </el-date-picker>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>检验单位</span>
              </div>
              <el-input v-model="dataSet.inspector" placeholder="请输入检验单位" maxlength="30"
                :disabled="redactState === 1"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>检验人</span>
              </div>
              <el-input v-model="dataSet.jyr" placeholder="检验人多人请使用英文逗号‘,’分隔（非必填）" maxlength="30"
                :disabled="redactState === 1"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>检验时间</span>
              </div>
              <el-date-picker v-model="dataSet.checkTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"
                :disabled="redactState === 1">
              </el-date-picker>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>检验依据</span>
              </div>
              <el-select v-model="dataSet.jyyj" placeholder="请选择检验依据" :disabled="redactState === 1">
                <el-option v-for="item in jyyjList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <!-- <div class="content_element_only">
              <div class="content_element_only_title">
                <span>检验类别</span>
              </div>
              <el-select v-model="dataSet.jylb" placeholder="请选择检验类别" :disabled="redactState === 1">
                <el-option v-for="item in jylbList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div> -->
            <div class="content_element_only_remark">
              <div class="content_element_only_title">
                <span>指标类别</span>
              </div>
              <el-checkbox-group v-model="zblbOpt" @change="zblbChange" style="width: 83.333%; text-align: left;">
                <el-checkbox  v-for="item in zblbList" :key="item.value" :label="item.label" :disabled="redactState === 1"></el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="content_element_only" v-if="dataSet.zblb && dataSet.zblb.indexOf('1')>=0">
              <div class="content_element_only_title">
                <span>质量指标检验结果</span>
              </div>
              <el-radio-group v-model="dataSet.zblb1" :disabled="redactState === 1">
                <el-radio label="达标">达标</el-radio>
                <el-radio label="不达标">不达标</el-radio>
              </el-radio-group>
            </div>
            <div class="content_element_only" v-if="dataSet.zblb && dataSet.zblb.indexOf('2')>=0">
              <div class="content_element_only_title">
                <span>存储品质检验结果</span>
              </div>
              <el-radio-group v-model="dataSet.zblb2" :disabled="redactState === 1">
                <el-radio label="宜存" class="zblb2">宜存</el-radio>
                <el-radio label="轻度不宜存" class="zblb2">轻度不宜存</el-radio>
                <el-radio label="重度不宜存" class="zblb2">重度不宜存</el-radio>
              </el-radio-group>
            </div>
            <div class="content_element_only" v-if="dataSet.zblb && dataSet.zblb.indexOf('3')>=0">
              <div class="content_element_only_title">
                <span>食品安全检验结果</span>
              </div>
              <el-radio-group v-model="dataSet.zblb3" :disabled="redactState === 1">
                <el-radio label="合格">合格</el-radio>
                <el-radio label="不合格">不合格</el-radio>
              </el-radio-group>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>质检结果</span>
              </div>
              <el-select v-model="dataSet.result" placeholder="请选择质检结果" :disabled="redactState === 1">
                <el-option v-for="item in resultList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="content_element_only">
                <div class="content_element_only_title">
                  <span>样品数量(kg)</span>
                </div>
                <el-input v-model="dataSet.ypsl" placeholder="请输入样品数量" maxlength="30"
                  :disabled="redactState === 1"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>样品等级</span>
              </div>
              <el-select v-model="dataSet.ypdj" placeholder="请选择样品等级" :disabled="redactState === 1">
                <el-option v-for="item in ypdjList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>是否正常存储年限</span>
              </div>
              <el-select v-model="dataSet.sfzcccnx" placeholder="请选择是否正常存储年限" :disabled="redactState === 1">
                <el-option v-for="item in sfzcccnxList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="content_element_only">
                <div class="content_element_only_title">
                  <span>审核人</span>
                </div>
                <el-input v-model="dataSet.shrxm" placeholder="请输入审核人" maxlength="30"
                  :disabled="redactState === 1"></el-input>
            </div>
            <div class="content_element_only uploadbox">
              <div class="content_element_only_title">
                <span>附件</span>
              </div>
              <el-upload class="upload-demo" ref="elupload" action="#" multiple
                :disabled="redactState === 1" :file-list="fileList" :on-remove="handleRemove"
                :before-remove="beforeRemove" :on-preview="handlePreview"  :on-change="handleChange" :auto-upload="false">
                <div class="fujiabox">+</div>
              </el-upload>
            </div>
            <div class="content_element_only_remark">
              <div class="content_element_only_title">
                <span>备注</span>
              </div>
              <el-input type="textarea" :rows="2" placeholder="" v-model="dataSet.remark"
                :disabled="redactState === 1"></el-input>
            </div>
          </div>
          <div class="content_element" style="border-bottom: 0">
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>质检类型</span>
              </div>
              <el-select v-model="dataSet.type" placeholder="请选择" @change="AssayData()" :disabled="redactState === 1 || redactState === 2">
                <el-option v-for="item in testTypeList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>质检模板</span>
              </div>
              <el-input v-model="dataSet.template" placeholder="" disabled maxlength="15"></el-input>
            </div>
          </div>
          <div class="Notice_alert">
            <el-table border :data="reportSons" style="width: 100%">
              <el-table-column prop="item" label="质检项" align="center"></el-table-column>
              <!-- oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,4})?).*$/g,'$1')" @blur="scope.row.value = $event.target.value" -->
              <el-table-column label="检测值" align="center">
                <template slot-scope="scope">
                  <span v-if="redactState === 1">{{ scope.row.value }}</span>
                  <el-input v-model="scope.row.value" v-else class="input-with-select"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="standard" label="判断标准" align="center"></el-table-column>
              <el-table-column label="结果" align="center">
                <template slot-scope="scope">
                  <span v-if="redactState === 1">{{ scope.row.result }}</span>
                  <el-select v-model="scope.row.result" v-else>
                    <el-option v-for="item in resultList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <!--        保存提示-->
        <el-dialog title="提示" :visible.sync="alertShow" width="30%" style="margin-top: 20vh">
          <span>是否确认保存</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="alertShow = false">取消</el-button>
            <el-button type="primary" @click="alertShow = false">确认</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { httpToken } from "@/utils/http";
import qs from "qs";
import { getdatadirid } from "@/utils/util";
import { getBarnInfoAllSons } from "@/utils/warehouseInOut";
import { fileUpload } from "@/utils/upload";
import { downloadFile } from "@/api/file";
export default {
  name: 'ReportAdd',
  data() {
    return {
      warehouseNumber: [],
      dataSet: {
        number: '',
        warehouseNumberId: '',
        // warehouseType: '',
        grainNature: '',
        grainBelong: '',
        foVariety: '',
        foGrade: '',
        quantity: '',
        inspector: '',
        jyr:'',
        checkTime: '',
        result: '',
        remark: '',
        type: '',
        template: '',
        jyyj:'1',
        zblb:'',
        zblb1:'',
        zblb2:'',
        zblb3:'',
        zbjgpd:[],
        shrxm:'',
        qysj:'',
        qyrxm:'',
        ypsl:'',
        ypdj:'',
        sfzcccnx:'',
        jylb:''
      },
      zblbOpt:[], // 指标类别选中
      reportSons: [],
      barnInfoList: [],
      testTypeList: [],
      resultList: [
        {
          label: '合格',
          value: '合格',
        },
        {
          label: '不合格',
          value: '不合格',
        }
      ],
      jyyjList: [
        {
          label: '国标',
          value: '1',
        },
        {
          label: '其他',
          value: '0',
        }
      ],
      zblbList: [
        {
          label: '质量指标检验',
          value: '1',
        },
        {
          label: '存储品质检验',
          value: '2',
        },
        {
          label: '食品安全检验',
          value: '3',
        }
      ],
      sfzcccnxList: [
        {
          label: '否',
          value: '0',
        },
        {
          label: '是',
          value: '1',
        }
      ],
      jylbList:[{
          label: '入仓验收',
          value: '01',
        }, {
          label: '出仓检验',
          value: '02',
        },{
          label: '3月末普检',
          value: '03',
        },{
          label: '9月末普检',
          value: '04',
        },{
          label: '入仓初检',
          value: '05',
        },{
          label: '月度检查',
          value: '06',
        },{
          label: '3月末库内普查',
          value: '07',
        },{
          label: '9月末库内普查',
          value: '08',
        }],
      ypdjList:getdatadirid('grain_level'),
      alertShow: false,
      ids: '',
      // 新增0，详情1，编辑2
      redactState: 0,
      fileList: [],
      regMorePeople: /^[\u4E00-\u9FA5,',']+$/,  // 多人分割校验
    }
  },
  methods: {
    //文件移除前钩子
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    //文件移除操作
    handleRemove(file, fileList) {
      fileUpload.delFile(file.id,
        (res) => {
          if (res.data.code == 200) {
            this.$message({
              message: "文件删除成功",
              type: "success",
              showClose: true,
            });
          }
        }
      )
      this.fileList = fileList
    },
    // zblbChange
    zblbChange(val){
      let zblbList = this.zblbList
      let zblb = []
      zblbList.forEach((item)=>{
        if(val.includes(item.label)){
          zblb.push(item.value)
        }
      })
      this.$nextTick(()=>{
        this.dataSet.zblb= zblb.join("#")
      })
    },
    //点击文件列表中已上传文件进行下载
    handlePreview(file) {
      if (file.id) {
        downloadFile(file.id)
      } else {
        // this.$message.error("文件未上传或文件id不存在")
      }
    },
    // 上传文件获取
    getUpload() {
      let fileList = []
      this.$refs.elupload.uploadFiles.forEach((item) => {
        // 判断是否存在缓存文件
        if (item.raw) {
          fileList.push(item.raw)
        }
      })
      return fileList;
    },
    // 多文件上传图片视频  文件
    task_flie_update(id, str) {
      let files = this.getUpload()
      if (files.length == 0) {
        this.goBack()
        return
      }
      let that = this
      fileUpload.uploadFiles(
        id, files, str,
        function (res) {
          if (res.data.code == 200) {
            that.$message({
              message: "文件上传成功",
              type: "success",
              showClose: true,
            });
          } else {
            that.$message({
              message: res.data.message,
              type: "success",
              showClose: true,
            });
          }
          that.goBack()
        },
        function (err) {
          that.$message.error("文件上传失败...")
        }
      );
    },
    // 获取已上传文件
    getfile(showid){
      let paramData = [
        {column: "form_id", type: "eq", value: showid},
        {column: "module_type", type: "eq", value: 'granary-quality-report'},
      ]
      httpToken({
        method: "post",
        url: "/sys-file2/all",
        data: qs.stringify({
          paramData: JSON.stringify(paramData),
        })
      }).then(res => {
        this.fileList = []
        res.data.data.forEach((item) => {
          this.fileList.push({
            id: item.id,
            name: item.fileChname,
            url: item.fileUrl
          })
        })
      })
    },
    // 获取数据详情
    getData(id) {
      let paramData = [{ column: 'id', type: 'eq', value: id }]
      httpToken({
        method: 'post',
        url: '/granary-quality-report/find',
        data: qs.stringify({ paramData: JSON.stringify(paramData) })
      }).then(res => {
        this.dataSet.type = ''
        this.warehouseNumber[1] = res.data.data.GranaryQualityReport.barnVId
        this.warehouseNumber[0] = res.data.data.GranaryQualityReport.warehouseNumberId
        this.dataSet = res.data.data.GranaryQualityReport
        let zbjgpd = []
        if(this.dataSet.zbjgpd){
          zbjgpd = this.dataSet.zbjgpd.split("#")
        }
        if(this.dataSet.zblb){
          let zblbList = this.zblbList
          let zblb = this.dataSet.zblb.split("#")
          let zblbOpt = []
          zblbList.forEach(item=>{
            if(zblb.includes(item.value)){
              zblbOpt.push(item.label)
              let ind = zblb.findIndex(num => num == item.value)
              this.dataSet['zblb'+item.value] = zbjgpd[ind];
            }
          })
          this.zblbOpt = zblbOpt
          
        }
        this.dataSet.quantity = (this.dataSet.quantity / 1000).toFixed(3)
        this.reportSons = res.data.data.GranaryQualityReportSon
        this.getfile(res.data.data.GranaryQualityReport.id)
      })
    },
    // 返回
    goBack() {
      this.$emit('update:comName', 'Report')
    },
    // 获取仓房信息
    getBarnData(number) {
      if (number) {
        this.dataSet.template = ''
        this.dataSet.type = ''
        this.dataSet.jylb = ''
        let paramData = [{ column: "id", type: "eq", value: number },]
        httpToken({
          method: 'post',
          url: '/barn-info-son/find',
          data: qs.stringify({ paramData: JSON.stringify(paramData) })
        }).then(res => {
          let barnData = res.data.data
          this.dataSet.grainNature = barnData.grainNature
          this.dataSet.grainBelong = barnData.grainBelong
          this.dataSet.foVariety = barnData.grainKind
          this.dataSet.grainKindId = barnData.grainKindId
          this.dataSet.foGrade = barnData.grainLevel
          this.dataSet.quantity = (barnData.actualSize / 1000).toFixed(3)
        })
      }
    },
    // 获取化验具体数据
    AssayData() {
      if(this.warehouseNumber.length==0){
        this.$message({
          type: 'info',
          message: '请先选择仓房'
        })
        this.dataSet.template = ''
        this.dataSet.type = ''
        this.dataSet.jylb = ''
        return
      }
      httpToken({
        method: 'post',
        url: '/granary-quality-report/getCheckM',
        data: qs.stringify({
          grKindId: this.dataSet.grainKindId,
          type: this.dataSet.type
        })
      }).then(res => {
        let AssayData = res.data.data
        if(AssayData){
          this.dataSet.template = AssayData.mouldName
          this.dataSet.jylb = AssayData.mouldStatusCn
          this.reportSons = []
          AssayData.details.forEach((item) => {
            this.reportSons.push({
              value: "",
              item: item.chItemCn,
              standard: item.chDescribe,
              result: ""
            })
          })
        }else{
          this.dataSet.template = ''
          this.dataSet.type = ''
          this.dataSet.jylb = ''
        }
      }).catch(err=>{
        this.dataSet.template = ''
        this.dataSet.type = ''
        this.dataSet.jylb = ''
      })
    },
    // 保存方法
    saveData() {
      this.dataSet['barnVId'] = this.warehouseNumber[1]
      this.dataSet['warehouseNumberId'] = this.warehouseNumber[0]
      let data = {
        ...this.dataSet
      }
      data.quantity = this.dataSet.quantity * 1000
      httpToken({
        method: 'post',
        url: '/granary-quality-report/add',
        data: qs.stringify({
          GranaryQualityReport: JSON.stringify(data),
          GranaryQualityReportSon: JSON.stringify(this.reportSons),
        })
      }).then(res => {
        if (res.data.code == 200) {
          this.$message({
            type: 'success',
            message: res.data.msg
          })
          this.task_flie_update(res.data.data,'granary-quality-report')
        }
      })
    },
    handleChange(file, fileList) {
        this.fileList = fileList;
      },
    // 保存按键
    saveButton() {
      if(this.warehouseNumber.length==0){
        this.$message({
          type: 'info',
          message: '请选择仓房'
        })
        return
      }
      let qyrxmBol = this.regMorePeople.test(this.dataSet.qyrxm)
      if(!this.dataSet.qyrxm || !qyrxmBol){
        this.$message({
          type: 'info',
          message: '请输入扦样人,多人请用英文逗号“,”隔开'
        })
        return
      }
      if(!this.dataSet.qysj){
        this.$message({
          type: 'info',
          message: '请选择扦样时间'
        })
        return
      }
      if(!this.dataSet.inspector){
        this.$message({
          type: 'info',
          message: '请输入检验单位'
        })
        return
      }
      let jyrBol = this.regMorePeople.test(this.dataSet.jyr)
      if(this.dataSet.jyr && !jyrBol){
        this.$message({
          type: 'info',
          message: '检验人多人请用英文逗号“,”隔开'
        })
        return
      }
      if(!this.dataSet.checkTime){
        this.$message({
          type: 'info',
          message: '请选择检验时间'
        })
        return
      }
      if(!this.dataSet.jyyj){
        this.$message({
          type: 'info',
          message: '请选择检验依据'
        })
        return
      }
      // if(!this.dataSet.jylb){
      //   this.$message({
      //     type: 'info',
      //     message: '请选择检验类别'
      //   })
      //   return
      // }
      if(!this.dataSet.zblb){
        this.$message({
          type: 'info',
          message: '请选择指标类别'
        })
        return
      }
      let zblbValArr = this.dataSet.zblb.split("#")
      let zbjgpd = []
      if(zblbValArr.includes('1') && !this.dataSet.zblb1){
        this.$message({
          type: 'info',
          message: '请选择质量指标检验结果'
        })
        return
      }else if(zblbValArr.includes('1')){
        zbjgpd.push(this.dataSet.zblb1)
      }
      
      if(zblbValArr.includes('2') && !this.dataSet.zblb2){
        this.$message({
          type: 'info',
          message: '请选择存储品质检验结果'
        })
        return
      }else if(zblbValArr.includes('2')){
        zbjgpd.push(this.dataSet.zblb2)
      }
      if(zblbValArr.includes('3') && !this.dataSet.zblb3){
        this.$message({
          type: 'info',
          message: '请选择食品安全检验结果'
        })
        return
      }else if(zblbValArr.includes('3')){
        zbjgpd.push(this.dataSet.zblb3)
      }
      this.dataSet.zbjgpd = zbjgpd.join("#")
      if(!this.dataSet.result){
        this.$message({
          type: 'info',
          message: '请选择质检结果'
        })
        return
      }
      if(!this.dataSet.ypsl){
        this.$message({
          type: 'info',
          message: '请输入样品数量'
        })
        return
      }
      if(!this.dataSet.ypdj){
        this.$message({
          type: 'info',
          message: '请输入样品等级'
        })
        return
      }
      if(!this.dataSet.sfzcccnx){
        this.$message({
          type: 'info',
          message: '请选择是否正常存储年限'
        })
        return
      }
      if(!this.dataSet.shrxm){
        this.$message({
          type: 'info',
          message: '请输入审核人姓名'
        })
        return
      }
      if(this.fileList.length==0){
        this.$message({
          type: 'info',
          message: '请先上传附件'
        })
        return
      }
      if(!this.dataSet.type){
        this.$message({
          type: 'info',
          message: '请选择质检类型'
        })
        return
      }
      let reportSons = this.reportSons

      for(let i=0;i<reportSons.length;i++){
        let item = reportSons[i]
        if(!item.value){
          this.$message({
            type: 'info',
            message: `请输入${item.item}检测值`
          })
          return
        }
        if(!item.result){
          this.$message({
            type: 'info',
            message: `请输入${item.item}结果`
          })
          return
        }
      }
      this.$confirm('是否确认保存这条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        
        this.saveData()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消保存'
        })
      })
    },
    // 修改按键
    updateButton() {
      if(!this.dataSet.qyrxm){
        this.$message({
          type: 'info',
          message: '请输入扦样人'
        })
        return
      }
      if(!this.dataSet.qysj){
        this.$message({
          type: 'info',
          message: '请选择扦样时间'
        })
        return
      }
      if(!this.dataSet.inspector){
        this.$message({
          type: 'info',
          message: '请输入检验单位'
        })
        return
      }
      if(!this.dataSet.checkTime){
        this.$message({
          type: 'info',
          message: '请选择检验时间'
        })
        return
      }
      if(!this.dataSet.jyyj){
        this.$message({
          type: 'info',
          message: '请选择检验依据'
        })
        return
      }
      // if(!this.dataSet.jylb){
      //   this.$message({
      //     type: 'info',
      //     message: '请选择检验类别'
      //   })
      //   return
      // }
      if(!this.dataSet.zblb){
        this.$message({
          type: 'info',
          message: '请选择指标类别'
        })
        return
      }
      let zblbValArr = this.dataSet.zblb.split("#")
      let zbjgpd = []
      if(zblbValArr.includes('1') && !this.dataSet.zblb1){
        this.$message({
          type: 'info',
          message: '请选择质量指标检验结果'
        })
        return
      }else if(zblbValArr.includes('1')){
        zbjgpd.push(this.dataSet.zblb1)
      }
      
      if(zblbValArr.includes('2') && !this.dataSet.zblb2){
        this.$message({
          type: 'info',
          message: '请选择存储品质检验结果'
        })
        return
      }else if(zblbValArr.includes('2')){
        zbjgpd.push(this.dataSet.zblb2)
      }
      if(zblbValArr.includes('3') && !this.dataSet.zblb3){
        this.$message({
          type: 'info',
          message: '请选择食品安全检验结果'
        })
        return
      }else if(zblbValArr.includes('3')){
        zbjgpd.push(this.dataSet.zblb3)
      }
      this.dataSet.zbjgpd = zbjgpd.join("#")
      if(!this.dataSet.result){
        this.$message({
          type: 'info',
          message: '请选择质检结果'
        })
        return
      }
      if(!this.dataSet.ypsl){
        this.$message({
          type: 'info',
          message: '请输入样品数量'
        })
        return
      }
      if(!this.dataSet.ypdj){
        this.$message({
          type: 'info',
          message: '请输入样品等级'
        })
        return
      }
      if(!this.dataSet.sfzcccnx){
        this.$message({
          type: 'info',
          message: '请选择是否正常存储年限'
        })
        return
      }
      if(!this.dataSet.shrxm){
        this.$message({
          type: 'info',
          message: '请输入审核人姓名'
        })
        return
      }
      if(this.fileList.length==0){
        this.$message({
          type: 'info',
          message: '请先上传附件'
        })
        return
      }
      let reportSons = this.reportSons
      for(let i=0;i<reportSons.length;i++){
        let item = reportSons[i]
        if(!item.value){
          this.$message({
            type: 'info',
            message: `请输入${item.item}检测值`
          })
          return
        }
        if(!item.result){
          this.$message({
            type: 'info',
            message: `请输入${item.item}结果`
          })
          return
        }
      }
      this.$confirm('是否确认保存这条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = {
          ...this.dataSet
        }
        data.quantity = this.dataSet.quantity * 1000
        httpToken({
          method: 'post',
          url: '/granary-quality-report/update',
          data: qs.stringify({
            GranaryQualityReport: JSON.stringify(data),
            GranaryQualityReportSon: JSON.stringify(this.reportSons),
          })
        }).then(res => {
          if (res.data.code == 200) {
            this.$message({
              type: 'success',
              message: res.data.msg
            })
            this.task_flie_update(res.data.data,'granary-quality-report')
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消保存'
        })
      })
    },
    // 获取流水号
    getNumberId() {
      httpToken({
        method: 'post',
        url: '/granary-quality-report/getNum',
      }).then(res => {
        this.dataSet.number = res.data.msg
      })
    }
  },
  async mounted() {
    this.barnInfoList = await getBarnInfoAllSons()
    if (this.$store.state.Quality.qualityState !== '') {
      this.redactState = Number(this.$store.state.Quality.qualityState)
      if (this.redactState === 0) {
        this.getNumberId()
      } else {
        if (this.$store.state.Quality.quaId !== '') {
          this.getData(this.$store.state.Quality.quaId)
        }
      }
    }
    this.testTypeList = getdatadirid('Testtype', 1)
  }
}
</script>

<style scoped lang="scss">
.rightconover {
  height: 100%;
  background-color: #f5f6fa;
  overflow: auto;

  .contentwidth {
    width: 100%;

    .ContentMargin {
      box-sizing: border-box;
      margin: 30px 35px;
      background-color: #ffffff;
      box-shadow: 0 3px 5px 0 #d5dade;
      padding: 30px 40px;
    }
  }
}

.content_head {
  display: flex;
  font-size: 18px;

  .content_head_ico {
    height: 17px;
    width: 4px;
    margin: auto 10px auto 0;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .content_head_title {
    margin: auto 0
  }

  .content_head_button {
    margin-left: auto;

    ::v-deep .el-button {
      padding: 10px 42px;
      font-size: 16px;

      span {
        font-size: 14px;
      }
    }

    .content_head_seek {
      display: inline-block;
      vertical-align: top;
      margin-left: 20px;

      ::v-deep .el-select {
        width: 100%;
      }

      ::v-deep .el-input-group__append {
        padding: 0 18px;
      }

      .input-with-select {
        .el-select {
          width: 65px;
        }

        ::v-deep .el-input__inner {
          text-transform: uppercase;
        }
      }

      .el-button {
        padding: 10px;
      }
    }
  }
}

.content_element {
  margin-top: 50px;
  padding-bottom: 10px;
  border-bottom: 1px solid #EBEBEB;
  text-align: right;
  display: flex;
  width: 100%;
  flex-wrap: wrap;

  .content_element_only {
    width: 33.3333%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 38px;

    .content_element_only_title {
      width: 120px;
      margin-right: 15px;
      font-size: 14px;

      .significance {
        color: red;
      }
    }

    ::v-deep .el-select {
      width: 50%;
      .el-input {
        width: 100%;
      }
    }
    ::v-deep .el-radio-group{
      width: 50%;
      text-align: left;
      .zblb2{
        margin-right: 8px;
        .el-radio__label{
          padding-left: 4px;
        }
      }
    }
    ::v-deep .el-cascader {
      width: 50%;

      .el-input {
        width: 100%;
      }
    }

    /*样式穿透*/
    ::v-deep .el-input {
      //width:12.5vw;
      width: 50%;
      background: #F4F7FD;
    }

    ::v-deep .el-input__inner {
      height: 36px;
      line-height: 36px;
    }

    ::v-deep .el-input__icon {
      line-height: 36px;
    }
  }

  .content_element_only_remark {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 38px;

    .content_element_only_title {
      width: 120px;
      margin-right: 15px;
      font-size: 14px;

      .significance {
        color: red;
      }
    }

    ::v-deep.el-textarea {
      width: 83.333%;
    }
  }
}

.Notice_alert {
  font-size: 14px;
  color: #969696;

  ::v-deep .el-table {
    -webkit-text-size-adjust: none;
    font-size: 14px;
  }

  ::v-deep .el-table th {
    background-color: #f4f7fd;
    color: #2A2A2A;
  }

  ::v-deep .el-table .el-table__cell {
    padding: 15px 0;
  }

  ::v-deep .el-table thead {
    color: #969696;
    -webkit-text-size-adjust: none;
    font-size: 14px;
  }
}

.uploadbox {
  .upload-demo {
    width: 50%;
    margin-bottom: 20px;
    text-align: left;

    .fujiabox {
      margin: 0 auto;
      cursor: pointer;
      box-sizing: border-box;
      width: 36px;
      height: 36px;
      line-height: 32px;
      text-align: center;
      background: #f4f7fd;
      border: 1px solid #bfbfbf;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #a0a0a0;
    }
  }
}
</style>
